import { FC } from 'react';
import { Form } from 'react-bootstrap';
import { Dropdown } from '@praktio/common-ui';

import { Days, Dates, NotificationFrequency } from '../../utils/constants';
import FormSection from '../common/FormSection/FormSection';

import './ReportNotification.scss';

interface IProps {
  notification?: IReportNotification;
  onChange: (value?: string, prop?: string) => void;
}

const today = new Date();
today.setUTCHours(13);
today.setUTCMinutes(0);
today.setUTCSeconds(0);

const FrequencyOptions = Object.keys(NotificationFrequency).map((k) => ({
  id: NotificationFrequency[k],
  label: k,
}));

const DayOptions = Object.keys(Days).map((k) => ({
  id: Days[k],
  label: k,
}));

const DateOptions = Dates.map((d) => ({
  id: d,
  label: d.toString(),
}));

const ReportNotification: FC<IProps> = ({ notification, onChange }) => {
  const { frequency, day, date } = notification || {};
  let dayDateDropdown = null;
  if (frequency === NotificationFrequency.Weekly) {
    dayDateDropdown = (
      <Dropdown
        id="day-dropdown"
        options={DayOptions}
        value={DayOptions.find((f) => f.id.toString() === day?.toString()) || DayOptions[0]}
        onSelect={(id) => onChange(id as any, 'day')}
      />
    );
  } else if (frequency === NotificationFrequency.Monthly) {
    dayDateDropdown = (
      <Dropdown
        id="date-dropdown"
        options={DateOptions}
        value={DateOptions.find((f) => f.id.toString() === date?.toString())}
        onSelect={(id) => onChange(id as any, 'date')}
      />
    );
  }
  return (
    <FormSection
      subheader="Notifications"
      className="ReportNotification"
      info={` Notifications will be sent to you at ${today.toLocaleTimeString(undefined, {
        hour12: true,
        hour: 'numeric',
      })} your local time, on the selected frequency.`}
    >
      <Form.Group>
        <div className="d-flex ReportNotification-notify">
          <div className="mr-2">Notify me</div>
          <Dropdown
            id="frequency-dropdown"
            options={FrequencyOptions}
            value={FrequencyOptions.find((f) => f.id === frequency)}
            onSelect={(id) => onChange(id as any, 'frequency')}
          />
          {!!dayDateDropdown && <div className="mr-2 ml-2"> on</div>}
          {dayDateDropdown}
        </div>
      </Form.Group>
    </FormSection>
  );
};

export default ReportNotification;
